<div>
  @if (!user.isGuest()) {
    <div class="row mt-1">
      <div class="col mb-3">
        <a (click)="continueToCheckout()"
          class="btn btn-info w-100p" [class.disabled]="!isContinueToCheckout ? true : null" >
          {{ 'Continue to checkout' | translate }}
          <i class="fa fa-angle-right pull-right"></i>
        </a>
      </div>
    </div>
  }
  @if (user.isGuest() && guestInCheckout) {
    <div class="row mt-1">
      <div class="col mb-3">
        <a (click)="continueToCheckout()"
          class="btn btn-info w-100p" [class.disabled]="!isContinueToCheckout ? true : null" >
          {{ 'Guest Checkout' | translate }}
          <i class="fa fa-angle-right pull-right"></i>
        </a>
      </div>
    </div>
  }
  @if (user.isGuest()) {
    <div class="row mt-1">
      <div class="col mb-3">
        <a (click)="continueToLogin()"
          class="btn btn-info w-100p" [class.disabled]="!isContinueToCheckout ? true : null" >
          {{ 'Member checkout' | translate }}
          <i class="fa fa-angle-right pull-right"></i>
        </a>
      </div>
    </div>
  }
  @if (checkoutMessage) {
    <div class="continue-message">{{checkoutMessage}}</div>
  }
</div>
